import { Component, computed, inject, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConnectionButtonConfigModel } from '../model/connection-button-config.model';
import { ConnectionActionService } from '../common';
import { ConnectionStatus } from '@vendasta/platform-integrations';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'platform-integration-connection-button',
  imports: [CommonModule, MatButtonModule],
  templateUrl: './connection-button.component.html',
  styleUrl: './connection-button.component.scss',
})
export class ConnectionButtonComponent {
  private readonly connectionActionService = inject(ConnectionActionService);

  config = input.required<ConnectionButtonConfigModel>();
  label = computed(() => this.updateLabel(this.connectionActionService.connectionStatus()));

  ngOnInit() {
    this.label();
  }

  private updateLabel(status: ConnectionStatus): string {
    switch (status) {
      case ConnectionStatus.CONNECTED:
        return this.config().disconnectLabel;
      case ConnectionStatus.DISCONNECTED:
        return this.config().reconnectLabel;
      case ConnectionStatus.PRECONNECTED:
        return this.config().resumeLabel;
      default:
        return this.config().connectLabel;
    }
  }

  onClick() {
    if (this.config().isDisabled) {
      return;
    }
    switch (this.connectionActionService.connectionStatus()) {
      case ConnectionStatus.CONNECTED:
        return this.config().disconnectAction();
      case ConnectionStatus.DISCONNECTED:
        return this.config().connectAction();
      case ConnectionStatus.PRECONNECTED:
        return this.config().preconnectAction();
      default:
        // this should cater for ConnectionStatus.UNSPECIFIED_STATUS as well,
        // Unspecified means there is no past connection
        return this.config().connectAction();
    }
  }
}
